import { Button } from 'reactstrap'

export default function PrintButton(props) {
  console.log('PrintButton rendered', props)

  const { elementId, includeCloseButton } = props

  function close() {
    window.close()
  }

  function print() {
    console.log('PrintButton clicked...')
    const printContents = document.getElementById(elementId).innerHTML
    const originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print()
    document.body.innerHTML = originalContents
    const printButton = document.getElementById('print-button')
    printButton.onclick = print
    const closeButton = document.getElementById('print-close-button')
    if (closeButton) {
      closeButton.onclick = close
    }
  }

  let closeButton = ''
  if (includeCloseButton) {
    closeButton = <Button id="print-close-button" type="button" onClick={close}>Close</Button>
  }
  return (
    <>
      <Button id="print-button" type="button" color="primary" style={{ margin: '10px' }} onClick={print}>Print</Button>
      {closeButton}
    </>
  )
}
